/**
 * Created by Jonas Wålekvist on 2017-12-11.
 */

import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {
    IStillImageBgIntroViewConfig,
    StillImageBgIntroView
} from "@nolimitcity/slot-game/bin/game/intro/StillImageBgIntroView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TombOfNefertitiGameAssets} from "../TombOfNefertitiGameAssets";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IBoxConfig, SpritePageFlipper} from "./pageFlipper/SpritePageFlipper";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TombOfNefertiti} from "../TombOfNefertiti";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class TombOfNefertitiIntroView extends StillImageBgIntroView {

    private _logo: PIXI.Sprite;
    private _gfxContainer: PIXI.Container;

    private _bgMap: PIXI.Sprite;

    private _pageFlipView: SpritePageFlipper;
    private _pageBoxConfig: IBoxConfig [] = [];

    constructor(config: IStillImageBgIntroViewConfig) {
        super(config);

    }

    startPresentation(data?: ParsedServerData, onShowComplete?: () => void): void {
        super.startPresentation(data, onShowComplete);
        if (TombOfNefertiti.api.gameClientConfiguration.isSet) {
            this.usJurChanges();
            this._pageFlipView.startSlideShow(7);
        } else {
            TombOfNefertiti.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION, () => {
                this.usJurChanges();
                this._pageFlipView.startSlideShow(7);
            });
        }
    }

    protected createGameGraphics(): PIXI.DisplayObject {
        this._gfxContainer = new PIXI.Container();

        this._logo = new PIXI.Sprite(GameResources.getTextures(TombOfNefertitiGameAssets.INTRO_LOGO)[0]);
        this._logo.anchor.set(0.5, 0);

        this._bgMap = new PIXI.Sprite(GameResources.getTextures("SplashMap")[0]);
        this._bgMap.anchor.set(0.5);

        this._gfxContainer.addChild(this._bgMap);
        this._gfxContainer.addChild(this._logo);

        this.createPageFlips();

        return this._gfxContainer;
    }

    protected onResizeGameGraphics(resizeData: IResizeData): void {
        if (resizeData.orientation === Orientation.PORTRAIT) {
            this._logo.scale.set(3);
            this._logo.position.set(0, -400);

            this._pageFlipView.scale.set(1.5);
            this._pageFlipView.position.set(0, 220);

            this._bgMap.y = 220;
        } else {
            this._logo.scale.set(1);
            this._logo.position.set(0, -288);

            this._pageFlipView.scale.set(1);
            this._pageFlipView.position.set(0, 50);

            this._bgMap.y = 65;
        }

        this._gfxContainer.position.set(this._screenWidth / 2, this._screenHeight * 0.4);

        this._pageFlipView.onResizeGameGraphics(resizeData);
    }

    private createPageFlips(): void {
        const raiderSpins:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("RaiderSpins_Multiplier")[0]);
        raiderSpins.name="raiderSpins";
        raiderSpins.x = -180;
        raiderSpins.y = 50;

        const raiderSpinsTitle:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("RaiderSpins")[0]);
        raiderSpinsTitle.anchor.set(0.5);
        raiderSpinsTitle.x = 180;
        raiderSpinsTitle.y = -280;

        raiderSpins.addChild(raiderSpinsTitle);

        const winRespin:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("WinRespin_reel")[0]);
        winRespin.x = -230;
        winRespin.y = 50;

        const winRespinTitle:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("WinRespin")[0]);
        winRespinTitle.anchor.set(0.5);
        winRespinTitle.x = 230;
        winRespinTitle.y = -280;

        winRespin.addChild(winRespinTitle);

        const wildRaider:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("WildRaider_Character")[0]);
        wildRaider.x = 230;
        wildRaider.y = 50;

        const wildRaiderTitle:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("WildRaider_title")[0]);
        wildRaiderTitle.anchor.set(0.5);
        wildRaiderTitle.x = -230;
        wildRaiderTitle.y = -280;

        wildRaider.addChild(wildRaiderTitle);

        const curseOfNefertiti:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("CurseOfNefertiti_Character")[0]);
        curseOfNefertiti.x = -230;
        curseOfNefertiti.y = 50;

        const curseOfNefertitiTitle:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("CurseOfNefertiti")[0]);
        curseOfNefertitiTitle.anchor.set(0.5);
        curseOfNefertitiTitle.x = 230;
        curseOfNefertitiTitle.y = -280;
        curseOfNefertiti.addChild(curseOfNefertitiTitle);

        this._pageBoxConfig = [
            {
                infoSprite: raiderSpins,
                text: Translation.translate("Unlimited win multiplier, increasing with every win.")
            },
            {
                infoSprite: winRespin,
                text: Translation.translate("Respin with higher multiplier, each win may award up to 2 respins.")
            },
            {
                infoSprite: wildRaider,
                text: Translation.translate("Random Wilds, guaranteed Wilds on the reels.")
            },
            {
                infoSprite: curseOfNefertiti,
                text: Translation.translate("Synced Reels, all middle reels reveal the same symbol.")
            }
        ];

        this._pageFlipView = new SpritePageFlipper(
            new PIXI.Sprite(GameResources.getTextures("navArrow")[0]),
            new PIXI.Sprite(GameResources.getTextures("navArrow")[0]),
            this._pageBoxConfig
        );
        this._pageFlipView.forceInitAnimations();
        this._pageFlipView.interactEnabled = true;

        this._gfxContainer.addChild(this._pageFlipView);

        this._pageFlipView.slideShowEnabled = true;
    }

    protected setButtonPosition(data: IResizeData): void {
        if (data.orientation === Orientation.PORTRAIT) {
            this._button.position.set(this._screenWidth * 0.5, this._screenHeight * 0.85);
        }
        else {
            this._button.position.set(this._screenWidth * 0.5, this._screenHeight * 0.92);
        }
    }

    private usJurChanges(): void {
        if (!TombOfNefertiti.api.gameClientConfiguration.showLowProbabilityGfx) {
            this._pageBoxConfig.forEach((ele) => {
                if (ele?.infoSprite?.name === "raiderSpins") {
                    const texture: PIXI.Texture = GameResources.getTextures("RaiderSpins_Multiplier_US")[0];
                    ele.infoSprite.texture = texture;
                }
            });
        }
    }
}